var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    fill: "#FFF",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.849 7.5L1.046 1.697a.924.924 0 01-.286-.7.994.994 0 01.306-.701.958.958 0 01.7-.296c.27 0 .504.099.701.296l6.06 6.079c.157.158.276.335.355.533.079.197.118.394.118.592 0 .197-.04.394-.118.592a1.577 1.577 0 01-.356.533l-6.078 6.079a.912.912 0 01-.691.286.984.984 0 01-.691-.306.958.958 0 01-.296-.7c0-.27.099-.504.296-.701L6.849 7.5z"
  })));
}
export default SvgNext;